import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InsuranceCarriersSubscribersRoutingModule } from './insurance-carriers-routing.module';
import { InsuranceCarriersSubscribersComponent } from './insurance-carriers-subscribers.component';

// material
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TDOPipesModule } from '../../tdo-shared/tdo-pipes.module';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';


@NgModule({
  declarations: [InsuranceCarriersSubscribersComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InsuranceCarriersSubscribersRoutingModule,
        TDOPipesModule,

        // material
        MatProgressSpinnerModule,
        MatDividerModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatDatepickerModule,
        MatSelectModule,
        MatRadioModule,
        MatCheckboxModule,
        TdoControlsModule,
        MatProgressBarModule,

    ]
})
export class InsuranceCarriersSubscribersModule { }
